import { IconProps } from '@thecvlb/design-system/lib/src/common/Icon';

import {
  DEFAULT_MH_APPT_CODE,
  DEFAULT_TRT_APPT_CODE,
  DEFAULT_WH_APPT_CODE,
  DEFAULT_WM_APPT_CODE
} from 'constants/defaults';
import { PathName } from 'router/paths';

import { ProgramCategory } from 'models/programs.types';
import { DrugClass } from 'models/survey.types';

type ProgramConfig = {
  category: ProgramCategory;
  code: string;
  drugClass: DrugClass;
  icon: IconProps['name'];
  label: string;
  path: PathName;
};

export const PROGRAM_CONFIGS: ProgramConfig[] = [
  {
    category: 'weight-management',
    code: DEFAULT_WM_APPT_CODE,
    drugClass: 'GLP-1',
    icon: 'scale-outline',
    label: 'Weight management',
    path: PathName.Weight
  },
  {
    category: 'mental-health',
    code: DEFAULT_MH_APPT_CODE,
    drugClass: 'MH',
    icon: 'heartbeat',
    label: 'Mental health',
    path: PathName.MentalHealth
  },
  {
    category: 'women-health',
    code: DEFAULT_WH_APPT_CODE,
    drugClass: 'WH',
    icon: 'female',
    label: "Women's health",
    path: PathName.WomensHRT
  },
  {
    category: 'mens-health',
    code: DEFAULT_TRT_APPT_CODE,
    drugClass: 'TRT',
    icon: 'patient-male',
    label: "Men's health",
    path: PathName.MensTRT
  }
];

export const WM_DUMMY_ADVANTAGES = [
  'Access to GLP-1 prescription from a U.S.-licensed provider',
  'Complimentary metabolic lab testing',
  'Insurance coverage assistance for GLP-1 medications like Ozempic® and Wegovy®',
  'Ongoing clinical guidance and support'
];

export const BLUE_LINE_ADVANTAGES = [
  'Access to GLP-1 prescription from a U.S.-licensed provider',
  'Complimentary metabolic testing',
  'LifeMD-dedicated weight loss guidance',
  'Ongoing support through your goal weight'
];

export const OPTAVIA_DUMMY_ADVANTAGES = [
  'Access to GLP-1 prescriptions from a provider.',
  'Complimentary lab work and weight loss expert guidance.',
  'Ongoing support throughout your weight loss journey.'
];

export const FAQ_WM = [
  {
    id: '1',
    text: "GLP-1 medications work by mimicking the activity of a naturally occurring hormone in the body called GLP-1, which is released by your small intestine minutes after you eat. GLP-1 medications bind to GLP-1 receptors in the body, causing the stomach to empty at a slower rate. They also regulate the brain's hunger signals. As a result, you feel fuller faster, end up eating less, and lose more weight.",
    title: 'How do GLP-1s work for weight loss?'
  },
  {
    id: '2',
    text: "In addition to access to prescription GLP-1 medication, the LifeMD Weight Management Program provides a tailored approach that goes beyond the typical weight loss offerings. You'll receive medically-backed guidance from your care team throughout your entire weight loss journey.",
    title:
      'What makes the LifeMD Weight Management Program different from other Weight Management programs?'
  },
  {
    id: '3',
    text: "When you enroll in the LifeMD Weight Management Program, you'll gain access to a team of qualified healthcare professionals: board-certified doctors and nurse practitioners who are not only experienced in the field of Weight Management. Throughout your journey, you'll receive personalized guidance and attentive monitoring so you can get results you'll love.",
    title: 'Who will be on my care team and supporting me throughout the process?'
  },
  {
    id: '4',
    text: "Yes! Everything – from your initial visit, to support provided by a team of clinicians, to ongoing check-ins – adds up to comprehensive care from the comfort of your home where you're truly set up for weight loss success.",
    title: 'Is the LifeMD Weight Management Program completely online?'
  },
  {
    id: '5',
    text: 'The cost of GLP-1 medication is not included in the LifeMD Weight Management Program. However, LifeMD Insurance Assistance will work hands-on to get you the absolute lowest price for your medication.',
    title: 'Is GLP-1 medication included in the cost of the plan?'
  }
];
